import type { FaireProductEntity } from "../../entity_types/product";

export const atc_nf_chunks_10: FaireProductEntity = {
  token: "atc_nf_chunks_10",
  type: "product",
  name: "Mini Claw in Persephone",
  brandName: "Chunks",
  imageUrl:
    "https://cdn.shopify.com/s/files/1/0510/2698/5143/files/CLAW_MINI_PERSEPHONE_WBG_HIRES.jpg?v=1709861016",
  priceDollars: 7.95,
  msrpDollars: 16,
  description: "ATC migration seed product",
  tags: ["hair", "accessories", "chunks"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
